module.exports = __webpack_public_path__ + "static/girldog-9fa11cb3027945fd44c1607d5b9a95c8.png";